import { Icon } from '@iconify/react'
import { Backdrop, Box, Button, Card, CardContent, Container, Stack, Typography } from '@mui/material'
import { t } from 'i18next'
import React from 'react'
import { useAuth } from '../../hooks/useAuth'

function DisabledPlatform({
    link,
    open
}: { link?: string, open: boolean }) {

    const { disconnect } = useAuth()
    return (
        <Backdrop
            sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
            open={open}
        >
            <Card>
                <CardContent style={{ display: 'flex', flexDirection: 'column' }}>
                    <Icon icon='noto:warning' style={{ alignSelf: 'center', marginBottom: 8 }} width={36} height={36} />
                    <Typography textAlign={'center'} variant='subtitle2'>{t('platformDisabled')}</Typography>

                    <Stack direction={'row'} spacing={2} mt={5} flexWrap={'wrap'}>
                        <Button startIcon={<Icon icon='material-symbols-light:mail-outline' />} component='a' href='mailto:support@arioneo.com' size='small'>{t('contactArioneoTeam')}</Button>
                        {
                            link && <Button startIcon={<Icon icon='bi:credit-card-2-back' />} component='a' href={link} target='_blank' size='small'>{t('menu:billing')}</Button>
                        }

                        <Button color='error' startIcon={<Icon icon='hugeicons:logout-04' />} onClick={disconnect} size='small'>{t('navbar:profileOptions:logout')}</Button>
                    </Stack>
                </CardContent>
            </Card>
        </Backdrop>
    )
}

export default DisabledPlatform